import { createContext, useReducer, useState, useContext } from 'react'

export const ReviewTargetContext = createContext() 

export const reviewTargetReducer = (state, action) => {
    switch (action.type) {
        case 'SET_REVIEW_TARGET':
            return { reviewTargets: action.payload }
        case 'CREATE_REVIEW_TARGET':
            return { reviewTargets: [action.payload, ...state.reviewTargets] }
        case 'UPDATE_REVIEW_TARGET':
            return { reviewTargets: action.payload }
        case 'DELETE_REVIEW_TARGET':
            return { reviewTargets: state.reviewTargets.filter(u => u._id !== action.payload._id) }
        default:
            return state
    }
}

export const ReviewTargetContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(reviewTargetReducer, { targets: [] })
    const [reviewTarget, setReviewTarget] = useState(null)
    return (<ReviewTargetContext.Provider value={{ ...state, dispatch, reviewTarget, setReviewTarget}}>{ children }</ReviewTargetContext.Provider>)
}

export const useReviewTargetContext = () => {
    const context = useContext(ReviewTargetContext)
    if(!context) throw Error('useReviewTargetContext must be used inside an ReviewTargetContextProvider')
    return context
}